import { SiteLog } from '../../constants/SiteLogs';

export type SiteLogTableData = {
	worker: SiteLog['worker'];
	company: SiteLog['company']['name'];
	site: SiteLog['site']['name'];
	userType: string;
	date: string;
	in: string;
	out: string;
};

export type RowData = [
	SiteLogTableData['worker'],
	SiteLogTableData['company'],
	SiteLogTableData['site'],
	...string[],
];

export const signInBookCustomSearch = (
	searchString: string,
	data: RowData,
): boolean => {
	const [col1, col2, col3, ...logs] = data;
	const simpleRow = [col1.name, col1.mobileNumber, col2, col3, ...logs];
	return simpleRow.some((value) =>
		value.toLocaleLowerCase().includes(searchString.toLocaleLowerCase()),
	);
};
